module.exports = __webpack_public_path__ + "static/media/sms_active.ca3644c1.svg";